import { Box, useTheme, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import React, { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getTypeConfig, ReservationType } from 'src/utils/common';
import TourOverViewEntityList from './TourOverViewEntityList';
import dayjs from 'dayjs';
import { dateFormat } from 'src/utils/dateFormat';

const ManageReservationEntityInfo = () => {
  const theme = useTheme();
  const { reservationOverview } = useSelector((state) => state.reservationsSummaryReducer);
  const [selectedFilter, setSelectedFilter] = useState('All');

  const typeConfigs = getTypeConfig(theme);

  const { filterOptions, groupedByDate, sortedDates } = useMemo(() => {
    if (!reservationOverview) {
      return { filterOptions: [], groupedByDate: {}, sortedDates: [] };
    }

    const filters = new Set(['All']);
    const grouped = {};

    Object.values(typeConfigs).forEach((typeConfig) => {
      const entities = reservationOverview[typeConfig.label] || [];

      entities.forEach((item) => {
        if (typeConfig.type === ReservationType.hotel && item.HotelName) {
          filters.add(item.HotelName);
        } else {
          filters.add(typeConfig.label);
        }

        const matchesFilter = selectedFilter === 'All' ||
          (typeConfig.type === ReservationType.hotel && item.HotelName === selectedFilter) ||
          (typeConfig.label === selectedFilter);

        if (!matchesFilter) return;

        const checkInDate = item.CheckIn;
        if (checkInDate) {
          grouped[checkInDate] = grouped[checkInDate] || [];
          grouped[checkInDate].push({ ...item, config: typeConfig });
        }
      });
    });

    const dates = Object.keys(grouped).sort((a, b) => dayjs(a, dateFormat).diff(dayjs(b, dateFormat)));

    return {
      filterOptions: Array.from(filters),
      groupedByDate: grouped,
      sortedDates: dates
    };
  }, [reservationOverview, typeConfigs, selectedFilter]);

  if (!reservationOverview) return null;

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        mb: 2
      }}>
        <FormControl sx={{ minWidth: 200 }} size="small">
          <InputLabel id="entity-filter-label">Filter by</InputLabel>
          <Select
            labelId="entity-filter-label"
            value={selectedFilter}
            onChange={(e) => setSelectedFilter(e.target.value)}
            label="Filter Entities"
          >
            {filterOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      {sortedDates.map(date => (
        <TourOverViewEntityList
          key={date}
          items={groupedByDate[date]}
        />
      ))}
    </Box>
  );
};

export default ManageReservationEntityInfo;